import {
  AGGREGATOR_CODE_PREFIXES,
  AGGREGATOR_ITEM_NAME_MAX_CHARS,
  AGGREGATOR_ITEM_NOTE_PREFIX,
  ASSISTANT_FEEDBACK_MAX_LENGTH,
  ASSISTANT_FEEDBACK_MIN_LENGTH,
  ASSISTANT_HISTORY_MAX_TURNS,
  ASSISTANT_HISTORY_TURN_MAX_LENGTH,
  ASSISTANT_QUESTION_MAX_LENGTH,
  ASSISTANT_QUESTION_MIN_LENGTH,
  CASH_ALTERATION_ACTIONS,
  CASH_COUNT_BILLS,
  CASH_COUNT_COINS,
  CASH_COUNT_DENOMINATIONS,
  CASH_COUNT_MAX_QUANTITY,
  CASH_COUNT_STATION_NAME_MAX,
  CIBUS_CLAIM_STATUS_BY_ACTION,
  CIBUS_CODE_PREFIX,
  CIBUS_PACKAGE_STATUS_CODE,
  CLOSED_ORDERS_PAGE_SIZE_DEFAULT,
  CLOSED_ORDERS_PAGE_SIZE_MAX,
  CashDrawerOwnershipPatchSchema,
  DEFAULT_ATTENDANCE_REPORT_RULES,
  DEFAULT_ATTENDANCE_SUMMARY_ROWS,
  DEFAULT_DEPOSIT_RETURN_REMINDER_TIMING,
  DEFAULT_KITCHEN_BON_SCALE,
  E2E_RUN_BRANCH_PATTERN,
  E2E_RUN_TIERS,
  FAILED_CREDIT_RECOVERY_DELAY_MS,
  KIOSK_DINE_IN_CODE_PREFIX,
  MENU_SEARCH_SYNONYMS,
  MIN_ORDER_COMPLETION_LABEL,
  MIN_ORDER_COMPLETION_NOTE_PREFIX,
  MONEY_DECIMALS,
  POS_STREAM_EVENT_TYPES,
  PUBLIC_ATTENDANCE_LOCATION_MAX_AGE_MS,
  PUBLIC_ATTENDANCE_RADIUS_METERS,
  QUICK_CHARGE_CODE_PREFIX,
  SESSION_FILTER_OPTIONS_LIMIT,
  SHIFT_ACCOUNT_PERMISSION_KEYS,
  SYSTEM_HOUSE_ACCOUNT_LABELS,
  TENBIS_CLAIM_STATUS_BY_ACTION,
  TENBIS_CLOSING_TIME_FRAMES,
  TENBIS_CODE_PREFIX,
  TaxAllocationItemSchema,
  TaxAllocationPageSchema,
  TaxAllocationQuerySchema,
  TaxAllocationReplaceSchema,
  TaxConnectSchema,
  TaxConnectionViewSchema,
  TaxInvoiceRequestSchema,
  TaxInvoiceViewSchema,
  WOLT_CLAIM_STATUS_BY_ACTION,
  WOLT_CODE_PREFIX,
  accountantReportDeliveryPatchSchema,
  accountantReportRangeSchema,
  accountantReportSessionsSchema,
  aggregatorItemNoteName,
  aggregatorItemNoteOptions,
  allocateGlobalTip,
  allocateGlobalTipShare,
  allocateMoneyPortion,
  allocatePaymentlineTips,
  areaPrintRulePrinterMappingSchema,
  areaPrintRuleSchema,
  attendanceLocationSchema,
  attendanceQrEmailSchema,
  attendanceSummaryRowsSchema,
  buildAccountantReportHtml,
  buildAggregatorItemNote,
  buildJpegPdf,
  canAdministerShiftAccounts,
  cashAlterationActionSchema,
  cashCountExpectedCashFromReport,
  cashCountQuantitiesSchema,
  cashInDrawerFromReport,
  cibusChargeRequestSchema,
  cibusSettledStatusesInPhases,
  cibusStatusActionSchema,
  cibusVoidRequestSchema,
  clockAttendanceActionSchema,
  closedOrdersQuerySchema,
  compareShiftScheduleCandidates,
  computeCashCountTotal,
  depositReturnReminderTimingSchema,
  digitalMenuEmailSchema,
  digitalMenuEntitlementPatchSchema,
  digitalMenuPageSchema,
  digitalMenuSettingsPatchSchema,
  e2eRunStartSchema,
  emptyCashCountQuantities,
  expandMergeTableIds,
  expectedCashFromReport,
  formatChannelDesiredTime,
  formatWoltPreorderTime,
  getComboMoveSource,
  getPrinterDisplayName,
  getProductMenuCategoryIds,
  hasPendingComboComponents,
  isAggregatorOrderCode,
  isCibusClaimStatus,
  isComboMoveNameMatch,
  isKioskDineInOrderCode,
  isMinOrderCompletionNote,
  isQuickChargeOrderCode,
  isTenbisClaimStatus,
  isTenbisOrderCode,
  isWithinPublicAttendanceRadius,
  isWoltClaimStatus,
  isWoltDeliveredApplicable,
  kitchenBonScaleSchema,
  matchesSearchQuery,
  normalizeSearchText,
  publicAttendanceLocationSchema,
  publicAttendancePageSchema,
  publicAttendancePrintSlipSchema,
  publicAttendanceSlipSchema,
  publicClockAttendanceActionSchema,
  readJpegSize,
  resolveCibusPhase,
  resolveEffectiveMinimumOrder,
  resolveTenbisPhase,
  resolveTip,
  resolveWoltPhase,
  roundMoney,
  sendZReportEmailSchema,
  splitMoney,
  systemHouseAccountLabel,
  systemHouseAccountReceivableLabel,
  takeAwayChannelLabel,
  takeAwayCloseActionGroupId,
  tenbisChargeRequestSchema,
  tenbisRefundRequestSchema,
  tenbisSettledStatusesInPhases,
  tenbisStatusActionSchema,
  tenbisWebsiteModeRequestSchema,
  updateAreaPrintRulesSchema,
  updateBankTransferEnabledSchema,
  updateCashCountSubtractsCreditTipsSchema,
  updateCibusTenantConfigSchema,
  updateDepositReturnReminderTimingSchema,
  updateKitchenBonScaleSchema,
  updatePublicAttendanceLocationSchema,
  updateRoundAmountsSchema,
  updateShowCustomerNamesOnTablesSchema,
  updateTenbisTenantConfigSchema,
  updateWorkerCashDepositExcludesCreditTipsSchema,
  updateZReportEmailRecipientsSchema,
  upsertSessionCashCountSchema,
  woltOnboardingCodeSchema,
  woltOrderDetailSchema,
  woltSettledStatusesInPhases,
  woltStatusActionSchema,
  woltVenueOnlineSchema,
  woltWebhookPayloadSchema,
  zReportEmailPdfSchema,
  zReportEmailRecipientsSchema,
  zReportLayoutConfigSchema,
  zReportLayoutEntrySchema,
  zReportLayoutEntryTypeSchema
} from "./chunk-QWSHGKXN.mjs";

// src/utils/validation.util.ts
import { ObjectId } from "bson";
import { isEmpty } from "ramda";
import validator from "validator";
import { z } from "zod";

// src/utils/israeliId.util.ts
function isValidIsraeliID(id) {
  if (id.length > 9 || id.length < 5)
    return false;
  id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
  return Array.from(id, Number).reduce((counter, digit, i) => {
    const step = digit * (i % 2 + 1);
    return counter + (step > 9 ? step - 9 : step);
  }) % 10 === 0;
}

// src/utils/validation.util.ts
var errorMessages = {
  url: "\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4-URL \u05DE\u05DB\u05D9\u05DC\u05D4 \u05E0\u05EA\u05D9\u05D1 \u05DC\u05D0 \u05D7\u05D5\u05E7\u05D9",
  mongoId: "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05D6\u05D4\u05D4 \u05D9\u05D7\u05D5\u05D3\u05D9 \u05EA\u05E7\u05D9\u05DF",
  date: "\u05E4\u05D5\u05E8\u05DE\u05D8 \u05EA\u05D0\u05E8\u05D9\u05DA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF",
  minNumber: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E2\u05DC \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  maxNumber: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05E2\u05D3",
  numberString: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D7\u05D9\u05D5\u05D1\u05D9/\u05E9\u05DC\u05D9\u05DC\u05D9/\u05E9\u05DC\u05DD/\u05E2\u05E9\u05E8\u05D5\u05E0\u05D9",
  fixedNumber: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05E9\u05DC\u05DD",
  phone: "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF",
  positive: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D7\u05D9\u05D5\u05D1\u05D9",
  idNumber: "\u05EA\u05E2\u05D5\u05D3\u05EA \u05D6\u05D4\u05D5\u05EA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05E0\u05D4",
  required: "\u05D7\u05D5\u05D1\u05D4 \u05DC\u05D4\u05D6\u05D9\u05DF \u05E2\u05E8\u05DA \u05D1\u05E9\u05D3\u05D4 \u05D6\u05D4",
  enumOption: "\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E2\u05E8\u05DA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  alphabet: "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D1\u05D0\u05E0\u05D2\u05DC\u05D9\u05EA \u05D0\u05D5 \u05D1\u05E2\u05D1\u05E8\u05D9\u05EA \u05D1\u05DC\u05D1\u05D3",
  english: "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D1\u05D0\u05E0\u05D2\u05DC\u05D9\u05EA \u05D1\u05DC\u05D1\u05D3",
  hebrew: "\u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05D9\u05D5\u05EA \u05D0\u05D5\u05EA\u05D9\u05D5\u05EA \u05D1\u05E2\u05D1\u05E8\u05D9\u05EA \u05D1\u05DC\u05D1\u05D3",
  israeliID: "\u05DE\u05E1\u05E4\u05E8 \u05EA\u05E2\u05D5\u05D3\u05EA \u05D6\u05D4\u05D5\u05EA \u05D0\u05D9\u05E0\u05D5 \u05EA\u05E7\u05D9\u05DF",
  localPhone: "\u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05EA\u05E7\u05D9\u05DF",
  email: "\u05D4\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D0\u05D9\u05E0\u05D5 \u05EA\u05E7\u05D9\u05DF",
  alphanumericHebEn: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D8\u05E7\u05E1\u05D8 \u05D1\u05E2\u05D1\u05E8\u05D9\u05EA \u05D0\u05D5 \u05D0\u05E0\u05D2\u05DC\u05D9\u05EA, \u05D9\u05DB\u05D5\u05DC \u05DC\u05D4\u05DB\u05D9\u05DC \u05D2\u05DD \u05DE\u05E1\u05E4\u05E8\u05D9\u05DD",
  text: "\u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D8\u05E7\u05E1\u05D8 \u05EA\u05E7\u05D9\u05DF, \u05DC\u05DC\u05D0 \u05E1\u05D9\u05DE\u05E0\u05D9\u05DD \u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD (@,#,%,&,$,*,^,+,=,<,>,~,`,|,',/,_)",
  password: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D7\u05D9\u05D9\u05D1\u05EA \u05DC\u05D4\u05DB\u05D9\u05DC \u05DC\u05E4\u05D7\u05D5\u05EA \u05D0\u05D5\u05EA \u05D2\u05D3\u05D5\u05DC\u05D4 \u05D0\u05D7\u05EA, \u05D0\u05D5\u05EA \u05E7\u05D8\u05E0\u05D4 \u05D0\u05D7\u05EA, \u05E1\u05E4\u05E8\u05D4 \u05D0\u05D7\u05EA, \u05D5\u05E2\u05D3 \u05E9\u05DC\u05D5\u05E9\u05D4 \u05EA\u05D5\u05D5\u05D9\u05DD \u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD"
};
var stringSchema = z.string().trim().max(255);
var textAreaSchema = z.string().trim().max(2e3);
var dateLike = z.union([z.number(), z.string(), z.date()]);
var validRegex = /^[a-zA-Z0-9֐-׿-.,?!:';"(){}[\]/+\\ \n\t]*/giu;
var customValidation = {
  securePassword: stringSchema.regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]|:;"'<>,.?/~`]).{8,}$/,
    errorMessages.password
  ).refine(
    (val) => {
      const specialCharCount = (val.match(/[!@#$%^&*()_\-+={}[\]|:;"'<>,.?/~`]/g) || []).length;
      return specialCharCount <= 3;
    },
    { message: "\u05D4\u05E1\u05D9\u05E1\u05DE\u05D4 \u05D9\u05DB\u05D5\u05DC\u05D4 \u05DC\u05D4\u05DB\u05D9\u05DC \u05E2\u05D3 \u05E9\u05DC\u05D5\u05E9\u05D4 \u05EA\u05D5\u05D5\u05D9\u05DD \u05DE\u05D9\u05D5\u05D7\u05D3\u05D9\u05DD" }
  ),
  alphabet: stringSchema.regex(/^[a-zA-Z֐-׿() ,.'-]*$/i, errorMessages.alphabet),
  english: stringSchema.regex(/^[a-zA-Z]*$/i, errorMessages.english),
  username: z.string().regex(/^[a-zA-Z0-9]*$/, errorMessages.text).max(25, "Username cannot exceed 25 characters"),
  hebrew: stringSchema.regex(/^[֐-׿]*$/i, errorMessages.hebrew),
  israeliID: stringSchema.refine((val) => isValidIsraeliID(val), errorMessages.israeliID),
  phone: {
    localPhone: stringSchema.refine((str) => validator.isMobilePhone(str, ["he-IL"]), {
      message: errorMessages.localPhone
    }),
    optionalLocalPhone: stringSchema.refine((str) => validator.isMobilePhone(str, ["he-IL"]) || isEmpty(str), {
      message: errorMessages.localPhone
    }).nullish()
  },
  url: z.string().trim().url({ message: errorMessages.url }).max(1e3),
  email: stringSchema.email(errorMessages.email),
  dateLikeToDate: dateLike.pipe(
    z.coerce.date({
      invalid_type_error: errorMessages.date,
      required_error: errorMessages.required
    })
  ),
  age: z.coerce.number({ invalid_type_error: errorMessages.positive }).int().min(0, `${errorMessages.minNumber} 0`).max(120, `${errorMessages.maxNumber} 120`).nullish(),
  number: z.coerce.number().max(99999).min(-99999),
  alphanumericHebEn: stringSchema.refine((value) => {
    const isHebrew = validator.isAlphanumeric(value, "he", {
      ignore: "-, "
    });
    const isEnglish = validator.isAlphanumeric(value, "en-US", {
      ignore: "-, "
    });
    return isHebrew || isEnglish;
  }, errorMessages.alphanumericHebEn),
  enumOption: stringSchema.refine((value) => {
    const isHebrew = validator.isAlphanumeric(value, "he", {
      ignore: "'\\ /"
    });
    const isEnglish = validator.isAlphanumeric(value, "en-US", {
      ignore: "'\\ /"
    });
    return isHebrew || isEnglish;
  }, errorMessages.enumOption),
  text: stringSchema.regex(validRegex, errorMessages.text),
  longText: textAreaSchema.regex(validRegex, errorMessages.text),
  ObjectId: z.preprocess(
    (arg) => {
      if (ObjectId.isValid(arg)) {
        return new ObjectId(arg);
      } else {
        return void 0;
      }
    },
    z.instanceof(ObjectId),
    { invalid_type_error: errorMessages.mongoId }
  )
};
var CustomErrorMap = (error, ctx) => {
  switch (error.code) {
    case z.ZodIssueCode.invalid_date:
      return { message: errorMessages.date };
    case z.ZodIssueCode.invalid_type:
      if (error.received !== "undefined" && error.received !== "null") {
        return {
          message: `\u05E1\u05D5\u05D2 \u05D4\u05E2\u05E8\u05DA \u05E9\u05D2\u05D5\u05D9, \u05D4\u05E1\u05D5\u05D2 \u05D4\u05E8\u05E6\u05D5\u05D9 \u05D4\u05D5\u05D0 ${error.expected}`
        };
      } else {
        return { message: errorMessages.required };
      }
    case z.ZodIssueCode.invalid_enum_value:
      return { message: errorMessages.enumOption };
    case z.ZodIssueCode.too_big:
      if (error.type === "string") {
        return { message: `\u05DE\u05E1\u05E4\u05E8 \u05D4\u05EA\u05D5\u05D5\u05D9\u05DD \u05D4\u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05D4\u05D5\u05D0 ${error.maximum}` };
      }
      if (error.type === "array" || error.type === "set") {
        return {
          message: `\u05DE\u05E1\u05E4\u05E8 \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05DE\u05E7\u05E1\u05D9\u05DE\u05DC\u05D9 \u05D4\u05D5\u05D0 ${error.maximum}`
        };
      }
      return { message: `${errorMessages.maxNumber} ${error.maximum}` };
    case z.ZodIssueCode.too_small:
      if (error.type === "string") {
        return { message: `\u05DE\u05E1\u05E4\u05E8 \u05D4\u05EA\u05D5\u05D5\u05D9\u05DD \u05D4\u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05D4\u05D5\u05D0 ${error.minimum}` };
      }
      if (error.type === "array" || error.type === "set") {
        return {
          message: `\u05DE\u05E1\u05E4\u05E8 \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05DE\u05D9\u05E0\u05D9\u05DE\u05DC\u05D9 \u05D4\u05D5\u05D0 ${error.minimum}`
        };
      }
      return { message: `${errorMessages.minNumber} ${error.minimum}` };
  }
  return { message: ctx.defaultError };
};
z.setErrorMap(CustomErrorMap);

// src/health/health.model.ts
import { z as z2 } from "zod";
var HealthSchema = z2.object({
  text: customValidation.text
});

// src/auth/auth.model.ts
import { z as z4 } from "zod";

// src/user/user-role.model.ts
import { z as z3 } from "zod";
var UserRoleSchema = z3.enum(["super_admin", "admin", "user"]);

// src/auth/auth.model.ts
var LoginRequestSchema = z4.object({
  username: customValidation.username,
  password: z4.string().min(1)
});
var AuthUserSchema = z4.object({
  name: z4.string(),
  username: z4.string(),
  email: z4.string().email(),
  role: UserRoleSchema,
  tenantId: z4.string().nullable().optional(),
  tenantIds: z4.array(z4.string()).optional()
});
var AuthTenantOptionSchema = z4.object({
  tenantId: z4.string(),
  companyName: z4.string(),
  maintenanceMode: z4.boolean().optional(),
  photoUrl: z4.string().nullable().optional()
});
var LoginResponseSchema = z4.object({
  expiresIn: z4.number().int().positive(),
  user: AuthUserSchema
});

// src/user/super-admin-bootstrap.model.ts
import { z as z6 } from "zod";

// src/user/user-create-credentials.model.ts
import { z as z5 } from "zod";
var UserCreateCredentialsSchema = z5.object({
  name: customValidation.english,
  username: customValidation.username,
  email: customValidation.email,
  password: customValidation.securePassword
});

// src/user/super-admin-bootstrap.model.ts
var SuperAdminBootstrapSchema = UserCreateCredentialsSchema;
var SuperAdminBootstrapResponseSchema = z6.object({
  name: z6.string(),
  username: z6.string(),
  email: z6.string(),
  role: UserRoleSchema
});

// src/pos/attendance-face.model.ts
import { z as z7 } from "zod";
var attendanceFaceEnrollmentSchema = z7.object({
  imageDataUrl: z7.string().max(15e5).regex(/^data:image\/jpeg;base64,[A-Za-z0-9+/]+={0,2}$/),
  consentConfirmed: z7.literal(true)
}).strict();
var faceClockAttendanceSchema = clockAttendanceActionSchema.omit({ pin: true }).extend({
  imageDataUrl: attendanceFaceEnrollmentSchema.shape.imageDataUrl,
  requestId: z7.string().uuid(),
  location: publicAttendanceLocationSchema.optional()
}).superRefine((request, context) => {
  if (request.actionType === "clock_in" && !request.location)
    context.addIssue({
      code: z7.ZodIssueCode.custom,
      path: ["location"],
      message: "\u05D9\u05E9 \u05DC\u05D0\u05E4\u05E9\u05E8 \u05D2\u05D9\u05E9\u05D4 \u05DC\u05DE\u05D9\u05E7\u05D5\u05DD \u05E2\u05D3\u05DB\u05E0\u05D9"
    });
});
export {
  AGGREGATOR_CODE_PREFIXES,
  AGGREGATOR_ITEM_NAME_MAX_CHARS,
  AGGREGATOR_ITEM_NOTE_PREFIX,
  ASSISTANT_FEEDBACK_MAX_LENGTH,
  ASSISTANT_FEEDBACK_MIN_LENGTH,
  ASSISTANT_HISTORY_MAX_TURNS,
  ASSISTANT_HISTORY_TURN_MAX_LENGTH,
  ASSISTANT_QUESTION_MAX_LENGTH,
  ASSISTANT_QUESTION_MIN_LENGTH,
  AuthTenantOptionSchema,
  AuthUserSchema,
  CASH_ALTERATION_ACTIONS,
  CASH_COUNT_BILLS,
  CASH_COUNT_COINS,
  CASH_COUNT_DENOMINATIONS,
  CASH_COUNT_MAX_QUANTITY,
  CASH_COUNT_STATION_NAME_MAX,
  CIBUS_CLAIM_STATUS_BY_ACTION,
  CIBUS_CODE_PREFIX,
  CIBUS_PACKAGE_STATUS_CODE,
  CLOSED_ORDERS_PAGE_SIZE_DEFAULT,
  CLOSED_ORDERS_PAGE_SIZE_MAX,
  CashDrawerOwnershipPatchSchema,
  DEFAULT_ATTENDANCE_REPORT_RULES,
  DEFAULT_ATTENDANCE_SUMMARY_ROWS,
  DEFAULT_DEPOSIT_RETURN_REMINDER_TIMING,
  DEFAULT_KITCHEN_BON_SCALE,
  E2E_RUN_BRANCH_PATTERN,
  E2E_RUN_TIERS,
  FAILED_CREDIT_RECOVERY_DELAY_MS,
  HealthSchema,
  KIOSK_DINE_IN_CODE_PREFIX,
  LoginRequestSchema,
  LoginResponseSchema,
  MENU_SEARCH_SYNONYMS,
  MIN_ORDER_COMPLETION_LABEL,
  MIN_ORDER_COMPLETION_NOTE_PREFIX,
  MONEY_DECIMALS,
  POS_STREAM_EVENT_TYPES,
  PUBLIC_ATTENDANCE_LOCATION_MAX_AGE_MS,
  PUBLIC_ATTENDANCE_RADIUS_METERS,
  QUICK_CHARGE_CODE_PREFIX,
  SESSION_FILTER_OPTIONS_LIMIT,
  SHIFT_ACCOUNT_PERMISSION_KEYS,
  SYSTEM_HOUSE_ACCOUNT_LABELS,
  SuperAdminBootstrapResponseSchema,
  SuperAdminBootstrapSchema,
  TENBIS_CLAIM_STATUS_BY_ACTION,
  TENBIS_CLOSING_TIME_FRAMES,
  TENBIS_CODE_PREFIX,
  TaxAllocationItemSchema,
  TaxAllocationPageSchema,
  TaxAllocationQuerySchema,
  TaxAllocationReplaceSchema,
  TaxConnectSchema,
  TaxConnectionViewSchema,
  TaxInvoiceRequestSchema,
  TaxInvoiceViewSchema,
  UserCreateCredentialsSchema,
  UserRoleSchema,
  WOLT_CLAIM_STATUS_BY_ACTION,
  WOLT_CODE_PREFIX,
  accountantReportDeliveryPatchSchema,
  accountantReportRangeSchema,
  accountantReportSessionsSchema,
  aggregatorItemNoteName,
  aggregatorItemNoteOptions,
  allocateGlobalTip,
  allocateGlobalTipShare,
  allocateMoneyPortion,
  allocatePaymentlineTips,
  areaPrintRulePrinterMappingSchema,
  areaPrintRuleSchema,
  attendanceFaceEnrollmentSchema,
  attendanceLocationSchema,
  attendanceQrEmailSchema,
  attendanceSummaryRowsSchema,
  buildAccountantReportHtml,
  buildAggregatorItemNote,
  buildJpegPdf,
  canAdministerShiftAccounts,
  cashAlterationActionSchema,
  cashCountExpectedCashFromReport,
  cashCountQuantitiesSchema,
  cashInDrawerFromReport,
  cibusChargeRequestSchema,
  cibusSettledStatusesInPhases,
  cibusStatusActionSchema,
  cibusVoidRequestSchema,
  clockAttendanceActionSchema,
  closedOrdersQuerySchema,
  compareShiftScheduleCandidates,
  computeCashCountTotal,
  depositReturnReminderTimingSchema,
  digitalMenuEmailSchema,
  digitalMenuEntitlementPatchSchema,
  digitalMenuPageSchema,
  digitalMenuSettingsPatchSchema,
  e2eRunStartSchema,
  emptyCashCountQuantities,
  expandMergeTableIds,
  expectedCashFromReport,
  faceClockAttendanceSchema,
  formatChannelDesiredTime,
  formatChannelDesiredTime as formatTenbisDesiredTime,
  formatWoltPreorderTime,
  getComboMoveSource,
  getPrinterDisplayName,
  getProductMenuCategoryIds,
  hasPendingComboComponents,
  isAggregatorOrderCode,
  isCibusClaimStatus,
  isComboMoveNameMatch,
  isKioskDineInOrderCode,
  isMinOrderCompletionNote,
  isQuickChargeOrderCode,
  isTenbisClaimStatus,
  isTenbisOrderCode,
  isWithinPublicAttendanceRadius,
  isWoltClaimStatus,
  isWoltDeliveredApplicable,
  kitchenBonScaleSchema,
  matchesSearchQuery,
  normalizeSearchText,
  publicAttendanceLocationSchema,
  publicAttendancePageSchema,
  publicAttendancePrintSlipSchema,
  publicAttendanceSlipSchema,
  publicClockAttendanceActionSchema,
  readJpegSize,
  resolveCibusPhase,
  resolveEffectiveMinimumOrder,
  resolveTenbisPhase,
  resolveTip,
  resolveWoltPhase,
  roundMoney,
  sendZReportEmailSchema,
  splitMoney,
  systemHouseAccountLabel,
  systemHouseAccountReceivableLabel,
  takeAwayChannelLabel,
  takeAwayCloseActionGroupId,
  tenbisChargeRequestSchema,
  tenbisRefundRequestSchema,
  tenbisSettledStatusesInPhases,
  tenbisStatusActionSchema,
  tenbisWebsiteModeRequestSchema,
  updateAreaPrintRulesSchema,
  updateBankTransferEnabledSchema,
  updateCashCountSubtractsCreditTipsSchema,
  updateCibusTenantConfigSchema,
  updateDepositReturnReminderTimingSchema,
  updateKitchenBonScaleSchema,
  updatePublicAttendanceLocationSchema,
  updateRoundAmountsSchema,
  updateShowCustomerNamesOnTablesSchema,
  updateTenbisTenantConfigSchema,
  updateWorkerCashDepositExcludesCreditTipsSchema,
  updateZReportEmailRecipientsSchema,
  upsertSessionCashCountSchema,
  woltOnboardingCodeSchema,
  woltOrderDetailSchema,
  woltSettledStatusesInPhases,
  woltStatusActionSchema,
  woltVenueOnlineSchema,
  woltWebhookPayloadSchema,
  zReportEmailPdfSchema,
  zReportEmailRecipientsSchema,
  zReportLayoutConfigSchema,
  zReportLayoutEntrySchema,
  zReportLayoutEntryTypeSchema
};
